import { faFlagCheckered } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstatePropStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';

const FinishModal = ({ property, setShow, handleStatus }) => {
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handleFinish = async prop => {
    await handleStatus(prop);
    dispatch(getRealEstatePropStats(realEstate.id));
    handleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon={faFlagCheckered}
          title="Finalizar"
          size="1x"
          style={{ marginRight: 8, color: '#0b1727' }}
        />
        <Modal.Title>Finalizar propiedad</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          La propiedad de dirección{' '}
          <b>
            {property.location.street} {property.location.number}
          </b>{' '}
          se finalizará, lo que la marcará como una operación realizada.
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?
        </div>

        <ModalButtonsContainer>
          <ButtonClose
            text="Cancelar"
            funcion={handleClose}
            variant="secondary"
          />

          <ButtonAccept
            text="Finalizar"
            funcion={handleFinish}
            data={{
              id: property._id,
              status: 'finished'
            }}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

FinishModal.propTypes = {
  property: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default FinishModal;
